import { AlertSeverity } from '@aloft/toolkit-shared';
import { IconName, ProductColor } from '@aloft/toolkit-sui';

export const ALERT_SEVERITY_ICON_PROPS: Record<
  AlertSeverity,
  { icon: IconName; color: ProductColor }
> = {
  error: {
    icon: 'information-close',
    color: 'alertError',
  },
  warning: {
    icon: 'error-warning',
    color: 'alertWarning',
  },
};
